"use strict";

import * as React from 'react';
export const ThemeContext = /*#__PURE__*/React.createContext(undefined);
ThemeContext.displayName = 'ThemeContext';
//# sourceMappingURL=ThemeContext.js.map